import * as Yup from 'yup'

const seoValidation = Yup.object({
  metaTitle: Yup.string().required('Meta Title is required'),
  metaDescription: Yup.string().required('Meta Description is required'),
  metaKeyword: Yup.string().required('Meta Keyword is required'),
})

const footerValidation = Yup.object({
  description: Yup.string().required('Description is required'),
})

export default { seoValidation, footerValidation }
